import React, { useEffect, useState } from 'react'
import { CAlert, CContainer } from '@coreui/react'
import AppTabs from './layout/AppTabs'
import Topbar from './layout/Topbar'
import Login from './features/auth/Login'
import AgenciesPage from './features/agencies/AgenciesPage'
import DashboardPage from './features/dashboard/DashboardPage'
import GlobalParametersPage from './features/globalParameters/GlobalParametersPage'
import ScriptsPage from './features/scripts/ScriptsPage'
import BostonIAPage from './features/bostonIA/BostonIAPage'
import FullLoader from './shared/FullLoader'
import ErrorBoundary from './shared/ErrorBoundary'
import { request } from './services'

const DASHBOARD_PUBLIC_PATHS = new Set([
  '/bostonscripts/dashboard',
  '/dashboard',
  '/v2/bostonscripts-web/dashboard',
  '/v2/bostonscripts/dashboard',
])

function App() {
  const path = window.location.pathname.replace(/\/+$/, '')
  const normalizedPath = path || '/'
  // Dashboard publico: rutas productivas + dashboard.html para servirlo estatico (XAMPP)
  // Rutas REALES de producto:
  //   CERT: https://stgv2.bostonscripts.basset.la/v2/bostonscripts-web/dashboard
  //   PROD: https://v2.bostonscripts.basset.la/v2/bostonscripts-web/dashboard
  const isDashboard =
    DASHBOARD_PUBLIC_PATHS.has(normalizedPath) ||
    normalizedPath.endsWith('/dashboard.html') ||
    new URLSearchParams(window.location.search).has('dashboard')
  const [booting, setBooting] = useState(true)
  const [me, setMe] = useState(null)
  const [activeTab, setActiveTab] = useState('agencies')
  const [message, setMessage] = useState('')

  async function bootstrap() {
    setBooting(true)
    const meRes = await request('me')
    setMe(meRes.ok ? meRes.data : { has_jwt: false, env: 'PROD' })
    setBooting(false)
  }

  useEffect(() => {
    if (!isDashboard) bootstrap()
  }, [isDashboard])

  if (isDashboard) {
    console.log('[public dashboard route]', window.location.pathname, window.location.search)
    return (
      <ErrorBoundary zone="dashboard">
        <DashboardPage />
      </ErrorBoundary>
    )
  }

  if (booting) return <FullLoader />

  if (!me?.has_jwt) {
    return <Login onLoggedIn={bootstrap} env={me?.env || 'PROD'} />
  }

  return (
    <div className="app-shell">
      <Topbar me={me} onLogout={bootstrap} />
      <CContainer fluid className="container-x">
        {message ? (
          <CAlert color="danger" dismissible onClose={() => setMessage('')}>
            {message}
          </CAlert>
        ) : null}

        <AppTabs activeTab={activeTab} onChange={setActiveTab} />

        <ErrorBoundary zone={activeTab} key={activeTab}>
          {activeTab === 'agencies' ? <AgenciesPage onError={setMessage} /> : null}
          {activeTab === 'scripts' ? <ScriptsPage onError={setMessage} /> : null}
          {activeTab === 'global-parameters' ? <GlobalParametersPage onError={setMessage} /> : null}
          {activeTab === 'boston-ia' ? <BostonIAPage onError={setMessage} /> : null}
        </ErrorBoundary>
      </CContainer>
      <footer className="app-footer">
        <div className="app-footer-brand">
          <span className="app-footer-spark">✦</span>
          <span>Boston Scripts · panel de administracion · potenciado con IA</span>
        </div>
        <span className="app-footer-copy">© {new Date().getFullYear()} Basset · Boston</span>
      </footer>
    </div>
  )
}

export default App
